export type LocaleCode =
  | 'zh-TW'
  | 'zh-CN'
  | 'en'
  | 'id'
  | 'vi'
  | 'th'
  | 'ja'
  | 'ko'

export type LocaleOption = {
  code: LocaleCode
  label: string
  testId: string
}

/** Platform-fixed list (docs/i18n.md). M1 picker may expose a subset. */
export const PLATFORM_LOCALES: LocaleOption[] = [
  { code: 'zh-TW', label: '繁體中文', testId: 'lang-option-zh-TW' },
  { code: 'zh-CN', label: '简体中文', testId: 'lang-option-zh-CN' },
  { code: 'en', label: 'English', testId: 'lang-option-en' },
  { code: 'id', label: 'Bahasa Indonesia', testId: 'lang-option-id' },
  { code: 'vi', label: 'Tiếng Việt', testId: 'lang-option-vi' },
  { code: 'th', label: 'ภาษาไทย', testId: 'lang-option-th' },
  { code: 'ja', label: '日本語', testId: 'lang-option-ja' },
  { code: 'ko', label: '한국어', testId: 'lang-option-ko' },
]

export const DEFAULT_LOCALE: LocaleCode = 'zh-TW'

/** M1 skeleton: at least zh-TW + en switchable. */
export const M1_PICKER_LOCALES: LocaleCode[] = ['zh-TW', 'en']

/** M6: all eight platform locales. */
export const M6_PICKER_LOCALES: LocaleCode[] = [
  'zh-TW',
  'zh-CN',
  'en',
  'id',
  'vi',
  'th',
  'ja',
  'ko',
]

export function normalizeLocale(raw: string | null | undefined): LocaleCode {
  if (!raw) return DEFAULT_LOCALE
  const map: Record<string, LocaleCode> = {
    'zh-tw': 'zh-TW',
    'zh-TW': 'zh-TW',
    'zh-cn': 'zh-CN',
    'zh-CN': 'zh-CN',
    en: 'en',
    id: 'id',
    vi: 'vi',
    th: 'th',
    ja: 'ja',
    ko: 'ko',
  }
  return map[raw] ?? map[raw.toLowerCase()] ?? DEFAULT_LOCALE
}
